const OF_CONSULTATIONS = "консультаций"
const OF_PSYCHOLOGICAL = "психологических"

function nounDeclensionByNumeral(number: number, forms: string[]) {
    const two_digit = number % 100
    if (4 < two_digit && two_digit < 21) {
        return forms[2]
    }
    const ones_digit = number % 10
    if (ones_digit === 1) {
        return forms[0]
    } else if (0 < ones_digit && ones_digit < 5) {
        return forms[1]
    }
    return forms[2]
}

export function numberToYearsInRussian(number: number) {
    return nounDeclensionByNumeral(number, ["год", "года", "лет"])
}

export function numberToMinutesInRussianGenitive(number: number) {
    return nounDeclensionByNumeral(number, ["минуты", "минут", "минут"])
}

export function sessionNounDeclensionByNumeral(number: number) {
    return nounDeclensionByNumeral(number, ["сессию", "сессии", "сессий"])
}

export function numberOfPsychologistsAcc(number: number) {
    return nounDeclensionByNumeral(number, ["психолога", "психологов", "психологов"])
}

export function numberOfUse(number: number) {
    return nounDeclensionByNumeral(number, ["применение", "применения", "применений"])
}

export function consultationsByNumeral(number: number) {
    return nounDeclensionByNumeral(number, ["консультация", "консультации", OF_CONSULTATIONS])
}

export function consultationsByAdjective(number: number) {
    return nounDeclensionByNumeral(number, ["консультации", OF_CONSULTATIONS, OF_CONSULTATIONS])
}

export function psychologicalByNumeral(number: number) {
    return nounDeclensionByNumeral(number, ["психологическая", "психологические", OF_PSYCHOLOGICAL])
}

export function psychologicalByAdjective(number: number) {
    return nounDeclensionByNumeral(number, ["психологической", OF_PSYCHOLOGICAL, OF_PSYCHOLOGICAL])
}

export function numberOfProblems(number: number) {
    return nounDeclensionByNumeral(number, ["проблема", "проблем", "проблем"])
}

// TODO use numeralize.pluralize(count, one, two, five) from https://www.npmjs.com/package/numeralize-ru instead
